<a
  cft-teaser-card
  [image]="article.headerImage!"
  [routerLink]="article.path"
  class="w-full"
  [ngClass]="{
    'cft-teaser-card--hero': isHero,
  }"
  *transloco="let t"
>
  @if (article.readingTime) {
    <cft-chip colour="grey" [icon]="timeIcon"
      ><span
        [ngClass]="{
          inline: isHero,
          'hidden md:inline': !isHero,
        }"
        >{{ t('article.readingTimeMinutes', {value: article.readingTime}) }}</span
      ><span
        [ngClass]="{
          hidden: isHero,
          'md:hidden': !isHero,
        }"
        >{{ t('article.readingTimeMinutesMobile', {value: article.readingTime}) }}</span
      >
    </cft-chip>
  }

  <cft-teaser-card-title>{{ article.title }}</cft-teaser-card-title>
  @if (article.topic) {
    <cft-teaser-card-plot>{{ article.topic }}</cft-teaser-card-plot>
  }
  @if (article.author) {
    <cft-author [author]="article.author"></cft-author>
  }
</a>
